/**
 * @desc 订单作废
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<number>, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/cancel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
